import { useSlideEditorContext } from "@/components/slides/editor/SlideEditorContext";
import { nonAudioTypeSlide, nonImageTypeSlide, nonVideoTypeSlide } from "@/lib/constants/slides";
import { useAppSelector } from "@/store/hooks";
import { useState } from "react";
import { FiFilm, FiImage, FiMusic } from "react-icons/fi";
import { PanelTabs } from "../../PanelTabs";
import { AudioTab } from "./AudioTab";
import { ImageTab } from "./ImageTab";
import { VideoTab } from "./VideoTab";

export function MediaPanel() {
  const [activeTab, setActiveTab] = useState("image");
  const { slide } = useAppSelector((state) => state.slideEditor.present);

  if (!slide) return null;

  const slideType = slide.type;
  const knowledgeArea = slide.knowledgeArea;

  const imageDisabled =
    (nonImageTypeSlide[slideType] as readonly string[])?.includes(knowledgeArea) ?? false;

  const audioDisabled =
    (nonAudioTypeSlide[slideType] as readonly string[])?.includes(knowledgeArea) ?? false;

  const videoDisabled =
    (nonVideoTypeSlide[slideType] as readonly string[])?.includes(knowledgeArea) ?? false;

  const tabs = [
    {
      id: "image",
      label: "Image",
      icon: <FiImage className="h-3.5 w-3.5" />,
      component: ImageTab,
      disabled: imageDisabled,
    },
    {
      id: "audio",
      label: "Audio",
      icon: <FiMusic className="h-3.5 w-3.5" />,
      component: AudioTab,
      disabled: audioDisabled,
    },
    {
      id: "video",
      label: "Video",
      icon: <FiFilm className="h-3.5 w-3.5" />,
      component: VideoTab,
      disabled: videoDisabled,
    },
  ];

  const ActiveTabComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  const getDisabledState = () => {
    if (activeTab === "image") return imageDisabled;
    if (activeTab === "audio") return audioDisabled;
    if (activeTab === "video") return videoDisabled;
    return false;
  };

  return (
    <div className="px-2">
      {/* Section header */}
      <div className="mb-3">
        <h3 className="text-xs font-bold uppercase tracking-widest text-slate-400 dark:text-gray-500 px-1">
          Media Library
        </h3>
      </div>

      {/* Tabs */}
      <PanelTabs setActiveTab={setActiveTab} activeTab={activeTab} tabs={tabs} />

      {ActiveTabComponent && <ActiveTabComponent disabled={getDisabledState()} />}
    </div>
  );
}
